<template>
  <div class="container-graph" v-if="scoutGraphData">
    <div class="graph-box" v-for="(sc, idx) in scoutGraphData" :key="idx + '-graph'">
      <div class="doughnut-wrapper">
        <Doughnut
          class="doughnut"
          :width="240"
          :hegiht="120"
          :chart-data="sc"
          :options="options">
        </Doughnut>
      </div>
      <p class="main-percentage">
        {{getPercentage(sc.datasets[0].data)}}<br>
        <span style="font-size: 14px; color: #444;">({{sc.datasets[0].data[0]}})</span>
      </p>
      <p class="-label">{{titleList[idx]}}</p>
    </div>
    <div class="graph-box action" v-if="scouts.length > 0">
      <h2>一括送付アクション</h2>
      <p class="-title">スカウト種類</p>
      <select class="select is-small" v-model="allSendSetting.type">
        <option v-for="(s, idx) in scouts" :key="idx" :value="s">
          {{s.name}}
        </option>
      </select>
      <p class="-title">送付先</p>
      <select class="select is-small" v-model="allSendSetting.to">
        <option v-for="(t, idx) in type" :key="idx + '-type'" :value="idx">
          {{t}}
        </option>
      </select>
      <div class="-title -btn">
        <button class="button is-primary is-small" @click="setScout(allSendSetting)">一括で送る</button>
      </div>
    </div>
    <div class="graph-box action" v-if="scouts.length > 0">
      <h2 class="scout">自動スカウト設定</h2>
      <p class="-title">ステータス</p>
      <template v-if="scoutAutoSending.length === 0">
        <p class="-desc">設定なし</p>
      </template>
      <template v-else>
        <p class="-desc">現在自動設定は{{scoutAutoSending[0].parameter.isScout ? 'ON' : 'OFF'}}です</p>
      </template>
      <p class="-title">スカウト種類</p>
      <template v-if="scoutAutoSending.length === 0">
        <p class="-desc">設定なし</p>
      </template>
      <template v-else>
        <p class="-desc">{{autoScoutName}}</p>
      </template>
      <div class="-title -btn">
        <button class="button is-primary is-small" @click="$emit('changeModalAutoScout', true)">条件を設定する</button>
      </div>
    </div>
  </div>
</template>
<script>
import Doughnut from '@/components/Charts/Doughnut'
import sum from "@/functions/sum"
export default {
  name: 'ScoutGraphview',
  componentName: 'ScoutGraphview',
  components: {
    Doughnut
  },
  props: {
    scoutAutoSending: {
      type: Array,
      required: false
    },
    scoutGraphData: {
      type: Array,
      required: false
    },
    scouts: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      options: {
        cutoutPercentage: 85,
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          animateRotate: false
        },
        legend: {
          display: false
        }
      },
      titleList: [
        'スカウト送付割合',
        'スカウト反応割合',
        'スカウト再送割合'
      ],
      type: [
        '訪問者全体（未設定）',
        '有望フラグ（未設定）',
        '自社動機付けチャンスフラグ（未設定）',
      ],
      allSendSetting: {
        type: null,
        to: null
      }
    }
  },
  computed: {
    autoScoutName () {
      if (this.scoutAutoSending[0].parameter.scout) {
        for (const scout of this.scouts) {
          if (scout.pk === this.scoutAutoSending[0].parameter.scout.pk) {
            return scout.name
          }
        }
      }
      return null
    }
  },
  methods: {
    getPercentage (data) {
      return Number(data[0] / sum(data) * 100).toFixed(2) + '%'
    },
    setScout (data) {
      // null check
      if (data.type === null) {
        alert('スカウト種類をご入力ください。')
        return
      } else if (data.to === null) {
        alert('送付先をご入力ください。')
        return
      }
      this.$emit('setAllScout', data)
      this.allSendSetting = {
        type: null,
        to: null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container-graph {
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
$graph-box-width: 192px;
.graph-box {
  position: relative;
  width: $graph-box-width;
  height: 180px;
  margin: 16px 8px;
  border: solid thin #ccc;
  border-radius: 16px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
  .doughnut-wrapper {
    width: $graph-box-width;
    position: absolute;
    z-index: 2;
  }
  $doughnut-height: 120px;
  $doughnut-margin-top: 16px;
  .doughnut {
    margin-top: $doughnut-margin-top;
  }
  .main-percentage {
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: $doughnut-height / 2 + $doughnut-margin-top;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }
  .-label {
    color: #C82E42;
    margin-top: $doughnut-height + $doughnut-margin-top + 4px;
    font-weight: 600;
    text-align :center;
  }
  .-title {
    margin-bottom: 2px;
    width: 100%;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
  }
  select, option {
    width: 300px !important;
    margin-bottom: 4px;
  }
  .-btn {
    margin-top: 4px;
  }
}
.action {
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h2 {
    color: #C82E42;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .-desc {
    margin-bottom: 4px;
    width: 100%;
    text-align: left;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .scout {
    margin-bottom: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/ScoutGraphView.vue